import React from 'react';
import PropTypes from 'prop-types';

const ResponsiveTable = (props) => {

    return (
        <div className={`responsive-table ${props.className ? props.className : ''}`}>
            {props.title && <div className="table-title">{props.title}</div>}
            <table>
                <thead>
                <tr>
                    {props.data.headings.map((item, key) => {
                        return (
                            <td key={key} dangerouslySetInnerHTML={{__html: item}} />
                        );
                    })}
                </tr>
                </thead>
                <tbody>
                {props.data.rows.map((items, key) => {
                    return (
                        <tr key={key}>
                            {items.map((item, key) => {
                                return (
                                    <td key={key}><div dangerouslySetInnerHTML={{__html: item}} /></td>
                                );
                            })}
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );

};

ResponsiveTable.propTypes = {
    data: PropTypes.shape({
        headings: PropTypes.array,
        rows: PropTypes.array
    }).isRequired,
    className: PropTypes.string
};

export default ResponsiveTable;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/ResponsiveTable.js